import { render, staticRenderFns } from "./WatermarkEditor.vue?vue&type=template&id=608e7b8e&scoped=true&"
import script from "./WatermarkEditor.vue?vue&type=script&lang=js&"
export * from "./WatermarkEditor.vue?vue&type=script&lang=js&"
import style0 from "./WatermarkEditor.vue?vue&type=style&index=0&id=608e7b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608e7b8e",
  null
  
)

export default component.exports